const header = {
  header: {
    logOut: 'Wyloguj',
    enphaseStore: 'Sklep Enphase',
    enphaseSupport: 'Obsługa klienta Enphase',
    comingSoon: 'Już wkrótce',
    new: 'Nowe',
    dashboard: 'Pulpit nawigacyjny',
    systems: 'Systemy',
    account: 'Konto',
    services: 'Usługi',
    dataPrivacy: 'Dane i prywatność',
    support: 'Wsparcie',
    admin: 'Administrator',
    adminNew: 'Administrator (nowy)'
  }
};

export default header;
